'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getRecurringMerchItemConfigsAndPriceBreakdown = getRecurringMerchItemConfigsAndPriceBreakdown;
exports.getEligibleTermIds = getEligibleTermIds;
exports.getTermId = getTermId;
exports.getDiscountPercentage = getDiscountPercentage;
exports.createPurchaseConfig = createPurchaseConfig;
exports.calculatePrice = calculatePrice;
exports.calculatePriceAndItemConfig = calculatePriceAndItemConfig;
exports.mergePriceObjects = mergePriceObjects;
exports.getMultiplePriceBreakdowns = getMultiplePriceBreakdowns;
exports.calculateBundlePrice = calculateBundlePrice;

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

var _calculatedPriceAdapter = require('self-service-api/adapters/calculatedPriceAdapter');

var _calculatedPriceAdapter2 = _interopRequireDefault(_calculatedPriceAdapter);

var _Terms = require('self-service-api/constants/Terms');

var _TermIds = require('self-service-api/constants/TermIds');

var _ChargeTypes = require('self-service-api/constants/ChargeTypes');

var _itemConfigUtils = require('./itemConfigUtils');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _merchandiseUtils = require('pricing-pages-unified-ui/utils/merchandiseUtils');

var _GrowthSuiteEditionOnboardingMerchIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionOnboardingMerchIdMap');

var _GrowthSuiteEditionOnboardingMerchIdMap2 = _interopRequireDefault(_GrowthSuiteEditionOnboardingMerchIdMap);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _ConfigSelectors = require('pricing-pages-unified-ui/selectors/ConfigSelectors');

var _store = require('pricing-pages-unified-ui/utils/store');

var _store2 = _interopRequireDefault(_store);

var _PromotionSelectors = require('pricing-pages-unified-ui/selectors/PromotionSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getRecurringMerchItemConfigsAndPriceBreakdown(recurringMerchItemConfigs, pricingInfo) {
  return recurringMerchItemConfigs.map(function (itemConfig) {
    var merchId = itemConfig.merchandiseId;
    var calculatedMonthlyPrice = pricingInfo.monthly.priceBreakdown.find(function (breakdown) {
      return breakdown.merchandiseId === merchId;
    }).calculatedPrice;
    var fullMonthlyPrice = pricingInfo.monthly.priceBreakdown.find(function (breakdown) {
      return breakdown.merchandiseId === merchId;
    }).fullPrice;

    return _extends({}, itemConfig, {
      calculatedMonthlyPrice: calculatedMonthlyPrice,
      fullMonthlyPrice: fullMonthlyPrice
    });
  });
}

function getEligibleTermIds(_ref) {
  var eligiblePromotions = _ref.eligiblePromotions,
      merchandiseId = _ref.merchandiseId;

  var productEligiblePromotion = eligiblePromotions.merchEligibleForDirectPromotions && eligiblePromotions.merchEligibleForDirectPromotions[merchandiseId];

  if (productEligiblePromotion) {
    var isAppAuth = (0, _ConfigSelectors.isAppAuthSelector)(_store2.default.getState());
    var isSalesOrServicePro = merchandiseId === _MerchandiseIds.PRODUCT_SALES_PROFESSIONAL || merchandiseId === _MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL;

    // if on public pages, don't offer monthly term id for sales/service pro
    // see https://git.hubteam.com/HubSpotProtected/EligibilityEngine/issues/305
    // and https://git.hubteam.com/HubSpot/pricing-pages-unified-ui/issues/1248
    if (!isAppAuth && isSalesOrServicePro) {
      return {
        annual: productEligiblePromotion.annualOfferId,
        monthly: undefined
      };
    }

    return {
      annual: productEligiblePromotion.annualOfferId,
      monthly: productEligiblePromotion.monthlyOfferId
    };
  }

  // to keep a watch on merch not covered by the BE
  // will default to no discount for now
  _Raven2.default.captureMessage('Merchandise id not covered by EE promotions', {
    extra: {
      merchandiseId: merchandiseId
    }
  });
  return { annual: _TermIds.ANNUAL_NO_DISCOUNT, monthly: _TermIds.MONTHLY_NO_DISCOUNT };
}

function getTermId(_ref2) {
  var eligiblePromotions = _ref2.eligiblePromotions,
      merchandiseId = _ref2.merchandiseId,
      term = _ref2.term;

  var eligibleTermIds = getEligibleTermIds({
    eligiblePromotions: eligiblePromotions,
    merchandiseId: merchandiseId
  });

  if (term === _Terms.MONTHLY) return eligibleTermIds.monthly || eligibleTermIds.annual;
  return eligibleTermIds.annual || eligibleTermIds.monthly;
}

function _getTermIdOverride(_ref3) {
  var merchandiseId = _ref3.merchandiseId,
      term = _ref3.term,
      eligiblePromotions = _ref3.eligiblePromotions,
      _ref3$isGrowthSuite = _ref3.isGrowthSuite,
      isGrowthSuite = _ref3$isGrowthSuite === undefined ? false : _ref3$isGrowthSuite;

  var isRecurringMerch = _ImmutableMerchandiseIdMap2.default[merchandiseId].chargeType === _ChargeTypes.RECURRING;

  // Ignore growth suite promotion if an HSFX promotion exists
  if (isGrowthSuite && !(0, _PromotionSelectors.isHSFXEligibleSelector)(_store2.default.getState())) {
    return term === _Terms.MONTHLY ? _TermIds.MONTHLY_25_PERCENT_DISCOUNT : _TermIds.ANNUAL_25_PERCENT_DISCOUNT;
  }

  if (isRecurringMerch) {
    return getTermId({
      eligiblePromotions: eligiblePromotions,
      merchandiseId: merchandiseId,
      term: term
    });
  }
  return _TermIds.MONTHLY_NO_DISCOUNT;
}

function getDiscountPercentage(_ref4) {
  var eligiblePromotions = _ref4.eligiblePromotions,
      merchandiseId = _ref4.merchandiseId,
      termIdToUse = _ref4.termIdToUse;

  var promotionInfo = eligiblePromotions.merchEligibleForDirectPromotions && eligiblePromotions.merchEligibleForDirectPromotions[merchandiseId];

  if (promotionInfo && termIdToUse === promotionInfo.annualOfferId) {
    return promotionInfo.annualDiscount;
  }

  if (promotionInfo && termIdToUse === promotionInfo.monthlyOfferId) {
    return promotionInfo.monthlyDiscount;
  }

  return null;
}

function createPurchaseConfig(_ref5) {
  var eligiblePromotions = _ref5.eligiblePromotions,
      merchandiseId = _ref5.merchandiseId,
      currencyCode = _ref5.currencyCode,
      itemConfigurations = _ref5.itemConfigurations,
      term = _ref5.term,
      termId = _ref5.termId,
      _ref5$isGrowthSuite = _ref5.isGrowthSuite,
      isGrowthSuite = _ref5$isGrowthSuite === undefined ? false : _ref5$isGrowthSuite;

  var termIdToUse = termId || _getTermIdOverride({
    merchandiseId: merchandiseId,
    term: term,
    eligiblePromotions: eligiblePromotions,
    isGrowthSuite: isGrowthSuite
  });

  var discountPercentage = getDiscountPercentage({
    eligiblePromotions: eligiblePromotions,
    merchandiseId: merchandiseId,
    termIdToUse: termIdToUse
  });

  var purchaseConfig = {
    currencyCode: currencyCode,
    itemConfigurations: itemConfigurations,
    termId: termIdToUse,
    discountPercentage: discountPercentage
  };

  return purchaseConfig;
}

function calculatePrice(_ref6) {
  var currencyCode = _ref6.currencyCode,
      productData = _ref6.productData,
      currentSubscriptions = _ref6.currentSubscriptions,
      eligiblePromotions = _ref6.eligiblePromotions,
      itemConfigurations = _ref6.itemConfigurations,
      merchandiseId = _ref6.merchandiseId,
      term = _ref6.term,
      termId = _ref6.termId,
      _ref6$isGrowthSuite = _ref6.isGrowthSuite,
      isGrowthSuite = _ref6$isGrowthSuite === undefined ? false : _ref6$isGrowthSuite;

  var purchaseConfig = createPurchaseConfig({
    eligiblePromotions: eligiblePromotions,
    merchandiseId: merchandiseId,
    currencyCode: currencyCode,
    itemConfigurations: itemConfigurations,
    term: term,
    termId: termId,
    isGrowthSuite: isGrowthSuite
  });

  var calculatedPrice = (0, _calculatedPriceAdapter2.default)(productData, purchaseConfig, currentSubscriptions);

  return calculatedPrice;
}

function calculatePriceAndItemConfig(_ref7) {
  var currencyCode = _ref7.currencyCode,
      productData = _ref7.productData,
      currentSubscriptions = _ref7.currentSubscriptions,
      eligiblePromotions = _ref7.eligiblePromotions,
      additionalUnitQuantity = _ref7.additionalUnitQuantity,
      merchandiseId = _ref7.merchandiseId,
      requiredOnboarding = _ref7.requiredOnboarding,
      _ref7$term = _ref7.term,
      term = _ref7$term === undefined ? _Terms.MONTHLY : _ref7$term,
      _ref7$isGrowthSuite = _ref7.isGrowthSuite,
      isGrowthSuite = _ref7$isGrowthSuite === undefined ? false : _ref7$isGrowthSuite;

  return calculatePrice({
    currencyCode: currencyCode,
    productData: productData,
    currentSubscriptions: currentSubscriptions,
    eligiblePromotions: eligiblePromotions,
    merchandiseId: merchandiseId,
    term: term,
    itemConfigurations: (0, _itemConfigUtils.createItemConfigWithMandatoryMerch)({
      merchandiseId: merchandiseId,
      additionalUnitQuantity: additionalUnitQuantity,
      requiredOnboarding: requiredOnboarding,
      isGrowthSuite: isGrowthSuite
    }),
    isGrowthSuite: isGrowthSuite
  });
}

function mergePriceObjects(priceObjects) {
  var totalPrices = {
    monthly: {
      fullPrice: 0,
      calculatedPrice: 0,
      priceBreakdown: []
    },
    annually: {
      fullPrice: 0,
      calculatedPrice: 0,
      priceBreakdown: []
    },
    oneTimeFee: {
      fullPrice: 0,
      calculatedPrice: 0,
      priceBreakdown: []
    }
  };
  priceObjects.forEach(function (priceObject) {
    ['monthly', 'annually', 'oneTimeFee'].forEach(function (section) {
      totalPrices[section].fullPrice = totalPrices[section].fullPrice + priceObject[section].fullPrice;

      totalPrices[section].calculatedPrice = totalPrices[section].calculatedPrice + priceObject[section].calculatedPrice;

      totalPrices[section].priceBreakdown = [].concat(_toConsumableArray(totalPrices[section].priceBreakdown), _toConsumableArray(priceObject[section].priceBreakdown));
    });
  });
  return totalPrices;
}

function getMultiplePriceBreakdowns(_ref8) {
  var marketingPlanSelected = _ref8.marketingPlanSelected,
      salesPlanSelected = _ref8.salesPlanSelected,
      servicePlanSelected = _ref8.servicePlanSelected,
      marketingUnits = _ref8.marketingUnits,
      salesUnits = _ref8.salesUnits,
      serviceUnits = _ref8.serviceUnits,
      selectedAddOns = _ref8.selectedAddOns,
      selectedServices = _ref8.selectedServices,
      pricingDependencies = _ref8.pricingDependencies,
      _ref8$term = _ref8.term,
      term = _ref8$term === undefined ? 'monthly' : _ref8$term,
      _ref8$isGrowthSuite = _ref8.isGrowthSuite,
      isGrowthSuite = _ref8$isGrowthSuite === undefined ? false : _ref8$isGrowthSuite;

  var generatePriceObject = function generatePriceObject(merchandiseId, additionalUnitQuantity) {
    return calculatePriceAndItemConfig(_extends({}, pricingDependencies, {
      merchandiseId: merchandiseId,
      additionalUnitQuantity: additionalUnitQuantity,
      term: term,
      isGrowthSuite: isGrowthSuite
    }));
  };

  var priceObjects = [];
  if (salesPlanSelected) {
    priceObjects.push(generatePriceObject(salesPlanSelected, salesUnits));
  }
  if (servicePlanSelected) {
    priceObjects.push(generatePriceObject(servicePlanSelected, serviceUnits));
  }
  if (marketingPlanSelected) {
    var min = (0, _merchandiseUtils.includedAdditionalUnits)(marketingPlanSelected);
    priceObjects.push(generatePriceObject(marketingPlanSelected, min + marketingUnits));
  }

  selectedAddOns.forEach(function (merchandiseId) {
    priceObjects.push(generatePriceObject(merchandiseId));
  });

  selectedServices.forEach(function (merchandiseId) {
    priceObjects.push(calculatePriceAndItemConfig(_extends({}, pricingDependencies, {
      merchandiseId: merchandiseId,
      term: term,
      isGrowthSuite: false // services are never available for suite discount
    })));
  });

  if (isGrowthSuite) {
    // Arbitrarily use sales merch to determine the suite edition
    var edition = (0, _merchandiseUtils.merchandiseEdition)(salesPlanSelected);
    var suiteOnboardingMerchId = _GrowthSuiteEditionOnboardingMerchIdMap2.default[edition];

    if (suiteOnboardingMerchId) {
      priceObjects.push(generatePriceObject(suiteOnboardingMerchId));
    }
  }

  return priceObjects;
}

function calculateBundlePrice(_ref9) {
  var marketingPlanSelected = _ref9.marketingPlanSelected,
      salesPlanSelected = _ref9.salesPlanSelected,
      servicePlanSelected = _ref9.servicePlanSelected,
      _ref9$marketingUnits = _ref9.marketingUnits,
      marketingUnits = _ref9$marketingUnits === undefined ? 0 : _ref9$marketingUnits,
      _ref9$salesUnits = _ref9.salesUnits,
      salesUnits = _ref9$salesUnits === undefined ? 0 : _ref9$salesUnits,
      _ref9$serviceUnits = _ref9.serviceUnits,
      serviceUnits = _ref9$serviceUnits === undefined ? 0 : _ref9$serviceUnits,
      _ref9$selectedAddOns = _ref9.selectedAddOns,
      selectedAddOns = _ref9$selectedAddOns === undefined ? [] : _ref9$selectedAddOns,
      _ref9$selectedService = _ref9.selectedServices,
      selectedServices = _ref9$selectedService === undefined ? [] : _ref9$selectedService,
      pricingDependencies = _ref9.pricingDependencies,
      _ref9$term = _ref9.term,
      term = _ref9$term === undefined ? 'monthly' : _ref9$term,
      _ref9$isGrowthSuite = _ref9.isGrowthSuite,
      isGrowthSuite = _ref9$isGrowthSuite === undefined ? false : _ref9$isGrowthSuite;

  var priceObjects = getMultiplePriceBreakdowns({
    marketingPlanSelected: marketingPlanSelected,
    salesPlanSelected: salesPlanSelected,
    servicePlanSelected: servicePlanSelected,
    marketingUnits: marketingUnits,
    salesUnits: salesUnits,
    serviceUnits: serviceUnits,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices,
    pricingDependencies: pricingDependencies,
    term: term,
    isGrowthSuite: isGrowthSuite
  });

  var totalPrice = mergePriceObjects(priceObjects);
  return totalPrice;
}


//////////////////
// WEBPACK FOOTER
// ./js/utils/pricingUtils.js
// module id = 42
// module chunks = 3 4 5